export { DtvExternalServiceComparisonChartTabs as default } from './dtv-external-service-comparison-chart-tabs';
